import type { AppModule } from '@/app/app-module.types';
import { Search } from '@react-apps/design-system';
import { ContentIcon } from '@/shared/icons';
import { CONTENT_ROLES } from '@/shared/guards/roles';
import { contentContainer } from './di/container';
import { ContentRepositoryToken, HarrisonRepositoryToken } from './di/tokens';
import { contentRoutes } from './presentation/routes';

/**
 * Módulo de Conteúdo (= ContentModule no monolith): content items, assuntos,
 * visões e o grafo de classificação. Consome `/admin/content/*`. Exclusivo do
 * admin — aparece no grupo "Gerenciamento" da sidebar.
 */
export const contentModule: AppModule = {
  name: 'content',

  register(container) {
    container.register(
      ContentRepositoryToken,
      () => contentContainer.repository,
    );
    container.register(
      HarrisonRepositoryToken,
      () => contentContainer.harrisonRepository,
    );
  },

  routes: contentRoutes,

  // Grupo "Conteúdo" (DESEN-41): a página de conteúdos de hoje sai de
  // "Cadastros" como "Todos os conteúdos", ao lado da busca de provas.
  menu: [
    {
      label: 'Buscar provas',
      to: '/content/exams/search',
      icon: Search,
      section: 'content',
      order: 1,
      roles: CONTENT_ROLES,
    },
    {
      label: 'Todos os conteúdos',
      to: '/content',
      icon: ContentIcon,
      section: 'content',
      order: 2,
      roles: CONTENT_ROLES,
    },
  ],
};
